<template>
    <div>
        <div style="width: 100%;display: flex;align-items: center;">
            <button :theme="'success'" @click="handleClick" class="mr10 btn btn-sm btn-neutral"
                style="width: 87%;">
                保存信息
            </button>
            <button class="btn btn-sm" @click="exampleSetting3.primary.visible = true">
                <bk-icon type="cog-shape"></bk-icon>
            </button>
        </div>
        <div style="display: flex;margin-bottom: 10px;align-items: center;margin-top: 10px;">

            <div class="label1 can-copy" v-bk-tooltips="'变量名:${title}'" v-bk-copy="'${title}'">标题：</div>
            <div style="width: 70%;">
                <input type="text"
                    v-model="musicInfo.title"
                    class="input input-bordered input-sm w-full max-w-xs" />
            </div>
            <div class="ml-2">
                <button class="btn btn-sm" @click="toggleLock('title')">
                    <svg t="1705485846497" class="icon fill-current w-4 h-4" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3421" width="200" height="200"><path d="M244.072422 374.434133c-5.005681 11.805512-19.752318 17.979953-32.430556 12.403989-12.378359-4.733995-18.282396-19.479351-12.943516-32.152463 7.048449-17.981235 16.486964-34.192668 26.226639-49.480114a378.437652 378.437652 0 0 1 35.940684-43.332585 280.427042 280.427042 0 0 1 43.910558-35.961188 275.658446 275.658446 0 0 1 49.544191-27.11987c12.678238-5.331191 27.723474 0.598477 32.429274 13.545838 5.60544 11.805512-0.598477 27.121151-13.276715 32.12555a264.739757 264.739757 0 0 0-40.973277 22.115471 333.234024 333.234024 0 0 0-36.267476 30.030239 267.88721 267.88721 0 0 0-30.062277 36.559666 275.207345 275.207345 0 0 0-22.092403 41.265467z m572.426356 383.462556l178.937061 179.45352a41.00916 41.00916 0 0 1 0.299879 58.950667 42.003632 42.003632 0 0 1-58.657195 0L757.541703 816.516719a444.40473 444.40473 0 0 1-116.117436 70.452455 450.588143 450.588143 0 0 1-172.734425 34.192669 455.128625 455.128625 0 0 1-173.632782-34.192669 456.816409 456.816409 0 0 1-244.940022-245.525684l-1.170043-2.040205a451.589022 451.589022 0 0 1-33.029033-170.933867 443.242377 443.242377 0 0 1 34.199076-172.399945A453.776605 453.776605 0 0 1 468.689842 15.778274 454.901794 454.901794 0 0 1 641.126951 50.242628l0.298598 0.298598v-0.298598a463.787966 463.787966 0 0 1 147.104982 98.450178l1.740326 2.040205a454.945366 454.945366 0 0 1 96.398438 144.707228l0.897075 2.365716a446.939609 446.939609 0 0 1-0.897075 343.640098 465.801259 465.801259 0 0 1-70.165391 116.450636zM610.163754 126.870806A371.431494 371.431494 0 0 0 126.461996 326.994224c-18.01071 43.604271-27.424876 91.373534-27.424875 141.475194a378.76957 378.76957 0 0 0 26.5278 139.980922l0.897075 1.467359a380.959715 380.959715 0 0 0 80.449719 120.259361 368.02517 368.02517 0 0 0 120.281147 80.163936c43.03655 17.950478 90.784027 27.690154 141.49698 27.690154a365.467224 365.467224 0 0 0 260.585016-107.282525l0.570284-0.571565a374.376464 374.376464 0 0 0 80.204946-120.259361c18.256765-43.032705 27.968247-91.044179 27.968246-141.449563a368.039267 368.039267 0 0 0-27.096802-139.13639l-0.871444-2.040205c-18.609188-44.22966-44.835827-84.59677-78.136547-118.190962l-2.068399-1.76852c-34.197795-34.165756-75.171071-61.884104-119.681388-79.864057v-0.597196z m101.100394 341.598612a25.41799 25.41799 0 0 1 25.056596-25.052752 25.007898 25.007898 0 0 1 25.057879 25.052752 297.604754 297.604754 0 0 1-22.391002 112.561172l-0.299879 0.598478a292.432473 292.432473 0 0 1-157.987788 157.38931 291.206043 291.206043 0 0 1-112.006267 22.658843 25.039937 25.039937 0 1 1 0-50.078592c31.525792 0 63.064398-6.499952 93.127957-18.278552a241.078753 241.078753 0 0 0 78.430018-52.744187 237.107272 237.107272 0 0 0 52.158525-77.796939l0.871444-1.170042a246.677785 246.677785 0 0 0 17.983798-93.139491z"></path></svg>
                </button>
            </div>
        </div>
        <div v-for="(item, index) in showFields" :key="'l1' + index">
            <div class="edit-item" v-if="item === 'filename'">

                <div class="label1 can-copy" v-bk-tooltips="'变量名:${filename}'" v-bk-copy="'${filename}'">
                    文件名：
                </div>
                <div style="width: 70%;">
                    <input type="text"
                        v-model="musicInfo.filename"
                        class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div class="edit-item can-copy" v-else-if="item === 'artist'">

                <div class="label1" v-bk-tooltips="'变量名:${artist}'" v-bk-copy="'${artist}'">艺术家：</div>
                <div style="width: 70%;">
                    <input type="text"
                        v-model="musicInfo.artist"
                        class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div class="edit-item can-copy" v-else-if="item === 'album'">

                <div class="label1" v-bk-tooltips="'变量名:${album}'" v-bk-copy="'${album}'">专辑：</div>
                <div style="width: 70%;">
                    <input type="text"
                        v-model="musicInfo.album"
                        class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div class="edit-item can-copy" v-else-if="item === 'albumartist'">

                <div class="label1" v-bk-tooltips="'变量名:${albumartist}'" v-bk-copy="'${albumartist}'">
                    专辑艺术家：
                </div>
                <div style="width: 70%;">
                    <div class="w-full max-w-xs">
                        <bk-tag-input
                            v-model="albumArtistInputList"
                            :list="albumArtistList"
                            :trigger="'focus'"
                            :max-data="1"
                            :allow-create="true"
                            :allow-auto-match="true"
                            :has-delete-icon="false">
                        </bk-tag-input>
                    </div>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'genre'">

                <div class="label1">风格：</div>
                <div style="width: 70%;">
                    <div class="w-full max-w-xs">
                        <bk-tag-input
                            v-model="genreInputList"
                            :list="genreList"
                            :allow-create="true"
                            :trigger="'focus'"
                            :max-data="1"
                            :allow-auto-match="true"
                            :has-delete-icon="false">
                        </bk-tag-input>
                    </div>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'language'">

                <div class="label1">语言：</div>
                <div style="width: 70%;">
                    <div class="w-full max-w-xs">
                        <bk-tag-input
                            v-model="languageInputList"
                            :list="languageList"
                            :allow-create="true"
                            :trigger="'focus'"
                            :max-data="1"
                            :allow-auto-match="true"
                            :has-delete-icon="false">
                        </bk-tag-input>
                    </div>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'year'">

                <div class="label1">年份：</div>
                <div style="width: 70%;">
                    <input type="text"
                        v-model="musicInfo.year"
                        class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div style="display: flex;margin-bottom: 10px;flex-direction: column;"
                v-else-if="item === 'lyrics'">
                <div style="display: flex;">
                    <div class="label1">歌词：</div>
                    <div style="display: flex;flex-direction: column;width: 77%;">
                        <div style="display: flex;">
                            <div class="form-control w-full max-w-xs">
                                <label class="label">
                                    <span class="label-text-alt">
                                        <div>
                                            <button class="btn btn-xs" @click.stop="cutOneSecondToLyrics(musicInfo.lyrics)" v-bk-tooltips="'裁剪歌词时间表'">
                                                <svg t="1700560074244" class="icon w-4 h-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M946 337.4c-2.3-8.6-11.1-13.7-19.7-11.3l-324.9 87.1 87-324.9c1.1-4.1 0.5-8.5-1.6-12.2s-5.6-6.4-9.7-7.5c-31-8.3-63.8-4.5-92.5 10.7-28 14.8-48.2 38.9-55.4 65.9l-74.8 279c-16.3-30.2-40.6-55.5-71.1-73.1-43.3-25-93.8-31.7-142.1-18.7l-82.7 22.2c-31.7 8.5-58.3 28.9-74.7 57.3-16.4 28.5-20.8 61.6-12.3 93.4L102 619c8.4 31.2 35.8 49.9 69.6 49.9 8.3 0 17.1-1.1 26-3.5l207.2-55.5-55.5 207.2c-12 44.9 7.5 85.1 46.4 95.5l113.7 30.5c10.6 2.8 21.4 4.2 32 4.2 21.3 0 42.4-5.6 61.3-16.5 28.5-16.4 48.8-43 57.3-74.7l22.2-82.7c22.9-85.3-17.3-172.9-91.9-213.2l279-74.8c57.8-15.6 93.7-84.7 76.7-148zM560.2 153.5c5-18.5 19.3-35.2 39.4-45.9 16.6-8.8 35.1-12.6 53.3-10.9l-87.3 325.9-83.5 22.4 78.1-291.5z m-18.7 421.4c82.6 22.1 131.8 107.4 109.7 190L629 847.6c-6.3 23.5-21.3 43.1-42.4 55.2-21 12.2-45.5 15.4-69 9.1L404 881.4c-21.6-5.8-31.2-28.4-23.7-56.2l60.3-225.1 98.2-26.3c0.8 0.5 1.7 0.9 2.7 1.1zM861 454.3l-671.7 180c-27.8 7.4-50.4-2.1-56.2-23.7l-30.5-113.7c-6.3-23.5-3.1-48 9.1-69 12.1-21 31.8-36.1 55.2-42.4l82.7-22.2c13.4-3.6 26.9-5.3 40.4-5.3 26.9 0 53.4 7 77.3 20.8 35.9 20.7 61.6 54.2 72.3 94.2 1.1 4.1 3.8 7.6 7.5 9.7s8.1 2.7 12.2 1.6l458.6-122.9c4 44.4-24.2 84.1-56.9 92.9z"></path><path d="M398.3 484.1c-5.8-21.7-17.9-41-34.8-55.7-6.7-5.8-16.8-5.1-22.6 1.6-5.8 6.7-5.1 16.8 1.6 22.6 12.1 10.5 20.7 24.2 24.8 39.7l4.2 15.5L195.7 555 175 477.5c-1.1-4.1-0.5-8.4 1.6-12.2 2.1-3.7 5.6-6.4 9.7-7.5l82.7-22.2c8.6-2.3 13.6-11.1 11.3-19.7-2.3-8.6-11.1-13.7-19.7-11.3L178 426.8c-12.4 3.3-22.8 11.3-29.2 22.4s-8.1 24.1-4.8 36.5l24.9 93c1.9 7.2 8.4 11.9 15.5 11.9 1.4 0 2.8-0.2 4.2-0.6l206.7-55.4c4.1-1.1 7.6-3.8 9.7-7.5s2.7-8.1 1.6-12.2l-8.3-30.8zM424.4 826c-1.1 4.1-0.5 8.5 1.6 12.2s5.6 6.4 9.7 7.5l93 24.9c4.2 1.1 8.3 1.6 12.4 1.6 21.3 0 40.8-14.2 46.5-35.7l22.2-82.7c7.8-28.9 3.8-59.2-11.3-85.2-15-26-39.2-44.6-68.2-52.4l-31-8.3c-4.1-1.1-8.5-0.5-12.2 1.6s-6.4 5.6-7.5 9.7l-16.4 61.2c-2.3 8.6 2.8 17.4 11.3 19.7 8.6 2.3 17.4-2.8 19.7-11.3l12.2-45.7 15.5 4.2c20.7 5.5 38 18.8 48.7 37.4 10.7 18.6 13.6 40.2 8.1 60.9l-22.2 82.7c-2.3 8.6-11.1 13.6-19.7 11.3l-77.5-20.8 14-52.3c2.3-8.6-2.8-17.4-11.3-19.7s-17.4 2.8-19.7 11.3L424.4 826z"></path></svg>
                                            </button>
                                            <button class="btn btn-xs ml-1" @click="formatSecondToLyrics(musicInfo.lyrics)" v-bk-tooltips="'格式化时间'">
                                                <svg t="1710489411790" class="w-4 h-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9709" width="200" height="200"><path d="M345.6 407.04c2.56 2.56 5.12 7.68 5.12 10.24s-2.56 7.68-5.12 10.24c-2.56 2.56-7.68 5.12-12.8 5.12h-40.96v138.24c0 5.12-2.56 7.68-5.12 10.24-2.56 2.56-7.68 5.12-12.8 5.12s-7.68-2.56-12.8-5.12c-2.56-2.56-5.12-7.68-5.12-10.24v-138.24H217.6c-5.12 0-7.68-2.56-12.8-5.12-2.56-2.56-5.12-7.68-5.12-10.24 0-5.12 2.56-7.68 5.12-10.24s7.68-5.12 10.24-5.12H332.8c5.12 2.56 7.68 2.56 12.8 5.12zM404.48 583.68c-2.56 2.56-7.68 5.12-12.8 5.12s-7.68-2.56-12.8-5.12c-2.56-2.56-5.12-7.68-5.12-10.24v-151.04c0-5.12 2.56-7.68 5.12-10.24 2.56-2.56 7.68-5.12 12.8-5.12s7.68 2.56 10.24 5.12c2.56 2.56 5.12 7.68 5.12 10.24v151.04c2.56 2.56 0 5.12-2.56 10.24zM619.52 407.04c2.56 2.56 5.12 7.68 5.12 10.24v151.04c0 5.12-2.56 7.68-5.12 10.24-2.56 2.56-7.68 5.12-12.8 5.12s-7.68-2.56-12.8-5.12c-2.56-2.56-5.12-7.68-5.12-12.8V460.8l-43.52 66.56-5.12 5.12c0 5.12-2.56 5.12-5.12 5.12s-5.12 0-7.68-2.56c-2.56-2.56-5.12-2.56-5.12-5.12L478.72 460.8v107.52c0 5.12-2.56 7.68-5.12 12.8s-7.68 5.12-10.24 5.12c-5.12 0-7.68-2.56-10.24-5.12-2.56-2.56-5.12-7.68-5.12-10.24v-151.04c0-5.12 2.56-7.68 5.12-10.24 2.56-2.56 7.68-5.12 12.8-5.12 2.56 0 5.12 0 7.68 2.56 2.56 2.56 5.12 2.56 5.12 5.12l56.32 87.04 58.88-87.04 5.12-5.12c2.56-2.56 5.12-2.56 7.68-2.56 5.12 0 10.24 0 12.8 2.56zM778.24 560.64c2.56 2.56 5.12 7.68 5.12 10.24 0 5.12-2.56 7.68-5.12 10.24-2.56 2.56-7.68 5.12-10.24 5.12h-87.04c-5.12 0-7.68-2.56-10.24-5.12-2.56-2.56-5.12-7.68-5.12-10.24v-151.04c0-5.12 2.56-7.68 5.12-10.24 2.56-2.56 7.68-5.12 10.24-5.12H768c5.12 0 7.68 2.56 10.24 5.12 2.56 2.56 5.12 7.68 5.12 10.24 0 5.12-2.56 7.68-5.12 10.24-2.56 2.56-7.68 5.12-12.8 5.12h-71.68v43.52h58.88c5.12 0 7.68 2.56 10.24 5.12 2.56 2.56 5.12 7.68 5.12 10.24 0 5.12-2.56 7.68-5.12 10.24-2.56 2.56-7.68 5.12-12.8 5.12H691.2v48.64h76.8c2.56 0 7.68 0 10.24 2.56z"></path><path d="M819.2 798.72H192c-43.52 0-79.36-35.84-79.36-79.36V289.28c0-43.52 35.84-79.36 79.36-79.36H819.2c43.52 0 79.36 35.84 79.36 79.36v430.08c0 43.52-35.84 79.36-79.36 79.36z m-627.2-537.6c-15.36 0-28.16 12.8-28.16 28.16v430.08c0 15.36 12.8 28.16 28.16 28.16H819.2c15.36 0 28.16-12.8 28.16-28.16V289.28c0-15.36-12.8-28.16-28.16-28.16H192z"></path></svg>
                                            </button>
                                            <button class="btn btn-xs ml-1" @click="extractToLyrics(musicInfo.lyrics)" v-bk-tooltips="'提取作曲家,作词家'">
                                                <svg t="1720074010675" class="w-4 h-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2496" width="200" height="200"><path d="M672 512h-320c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h320c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32zM704 672c0-17.066667-14.933333-32-32-32h-320c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h320c17.066667 0 32-14.933333 32-32zM352 768c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h234.666667c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32h-234.666667z" p-id="2497"></path><path d="M832 298.666667H586.666667c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32H810.666667v554.666666H213.333333V362.666667h74.666667c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32H192c-23.466667 0-42.666667 19.2-42.666667 42.666666v597.333334c0 23.466667 19.2 42.666667 42.666667 42.666666h640c23.466667 0 42.666667-19.2 42.666667-42.666666V341.333333c0-23.466667-19.2-42.666667-42.666667-42.666666z" p-id="2498"></path><path d="M354.133333 202.666667L405.333333 151.466667v243.2c0 17.066667 14.933333 32 32 32s32-14.933333 32-32V151.466667l51.2 51.2c12.8 12.8 32 12.8 44.8 0 12.8-12.8 12.8-32 0-44.8l-104.533333-104.533334c-2.133333-2.133333-6.4-4.266667-10.666667-6.4-4.266667-4.266667-8.533333-4.266667-12.8-4.266666s-8.533333 0-10.666666 2.133333c-4.266667 2.133333-8.533333 4.266667-10.666667 6.4l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 10.666667 14.933333 29.866667 14.933333 42.666666 2.133334z" p-id="2499"></path></svg>
                                            </button>
                                        </div>
                                    </span>
                                    <span class="label-text-alt">
                                        <div>
                                            <button class="btn btn-xs" @click="addOneSecondToLyrics(musicInfo.lyrics, 'add')" v-bk-tooltips="'歌词时间正向偏移 1 秒'">+</button>
                                            <button class="btn btn-xs" @click="addOneSecondToLyrics(musicInfo.lyrics)" v-bk-tooltips="'歌词时间反向偏移 1 秒'">-</button>
                                        </div>
                                    </span>
                                </label>
                                <textarea placeholder="请填入歌词" v-model="musicInfo.lyrics"
                                    class="textarea textarea-bordered textarea-xs w-full max-w-xs h-48">
                                            </textarea>
                                <label class="label">
                                    <span class="label-text-alt">
                                        <div style="display: flex;margin-top: 10px;margin-right: 20px;">
                                            <div class="text-xs mr-2 tooltip" data-tip="将元数据中的歌词导出为 ${filename}.lrc ">导出 lrc:</div>
                                            <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                                v-model="isSaveLyricsFile" />
                                        </div>
                                    </span>
                                    <span class="label-text-alt">
                                        <div style="display: flex;margin-top: 10px;">
                                            <div class="text-xs mr-2 tooltip" data-tip="将${filename}.lrc文件导入元数据中的歌词处">导入 lrc:</div>
                                            <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                                v-model="isImportLyricsFile" />
                                        </div>
                                    </span>
                                </label>
                            </div>
                            <div class="ml-6">
                                <button class="btn btn-sm" @click="translation()">
                                    <svg t="1706665302725" class="icon cursor-pointer w-5 h-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2539" width="200" height="200"><path d="M608 416h288c35.36 0 64 28.48 64 64v416c0 35.36-28.48 64-64 64H480c-35.36 0-64-28.48-64-64v-288H128c-35.36 0-64-28.48-64-64V128c0-35.36 28.48-64 64-64h416c35.36 0 64 28.48 64 64v288z m0 64v64c0 35.36-28.48 64-64 64h-64v256.032c0 17.664 14.304 31.968 31.968 31.968H864a31.968 31.968 0 0 0 31.968-31.968V512a31.968 31.968 0 0 0-31.968-31.968H608zM128 159.968V512c0 17.664 14.304 31.968 31.968 31.968H512a31.968 31.968 0 0 0 31.968-31.968V160A31.968 31.968 0 0 0 512.032 128H160A31.968 31.968 0 0 0 128 159.968z m64 244.288V243.36h112.736V176h46.752c6.4 0.928 9.632 1.824 9.632 2.752a10.56 10.56 0 0 1-1.376 4.128c-2.752 7.328-4.128 16.032-4.128 26.112v34.368h119.648v156.768h-50.88v-20.64h-68.768v118.272H306.112v-118.272H238.752v24.768H192z m46.72-122.368v60.48h67.392V281.92H238.752z m185.664 60.48V281.92h-68.768v60.48h68.768z m203.84 488H576L668.128 576h64.64l89.344 254.4h-54.976l-19.264-53.664h-100.384l-19.232 53.632z m33.024-96.256h72.864l-34.368-108.608h-1.376l-37.12 108.608zM896 320h-64a128 128 0 0 0-128-128V128a192 192 0 0 1 192 192zM128 704h64a128 128 0 0 0 128 128v64a192 192 0 0 1-192-192z"></path></svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex;margin-bottom: 10px;flex-direction: column;"
                v-else-if="item === 'lyrics_file'">
                <div style="display: flex;">
                    <div class="label1">歌词文件：</div>
                    <div style="display: flex;flex-direction: column;width: 77%;">
                        <div style="display: flex;">
                            <div class="form-control w-full max-w-xs">
                                <textarea placeholder="请填入歌词" v-model="musicInfo.lyrics_file"
                                    class="textarea textarea-bordered textarea-xs w-full max-w-xs h-48">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'comment'">

                <div class="label1">描述：</div>
                <div style="width: 70%;">
                    <textarea placeholder="请填入描述" v-model="musicInfo.comment"
                        class="textarea textarea-bordered textarea-xs w-full max-w-xs">
                    </textarea>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'description'">

                <div class="label1">描述2：</div>
                <div style="width: 70%;">
                    <textarea placeholder="请填入描述" v-model="musicInfo.description"
                        class="textarea textarea-bordered textarea-xs w-full max-w-xs">
                    </textarea>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'album_img'">

                <div class="label1">专辑封面：</div>
                <div style="display: flex;flex-direction: column;">
                    <div style="width: 70%;display: flex;flex-direction: column;" v-if="reloadImg">
                        <div>
                            <bk-upload
                                :files="musicInfo.files1"
                                :theme="'picture'"
                                :multiple="false"
                                :with-credentials="true"
                                :header="uploadHeader"
                                :handle-res-code="handleRes"
                                :size="{ maxFileSize: 5, maxImgSize: 20 }"
                                :url="uploadUrl"
                                name="upload_file"
                            ></bk-upload>
                        </div>
                        <div style="color: #63656e;font-size: 12px;display: flex;">
                            <div>({{ musicInfo.artwork_w }}*{{ musicInfo.artwork_h }})</div>
                            <div>{{ musicInfo.artwork_size }}MB</div>
                        </div>
                    </div>
                    <div style="display: flex;margin-top: 10px;">
                        <div class="text-xs mr-2">导出图片：</div>
                        <input type="checkbox" class="toggle toggle-xs toggle-primary"
                            v-model="isSaveAlbumCover" />
                        <div class="text-xs mr-2 ml-8">导入图片：</div>
                        <input type="checkbox" class="toggle toggle-xs toggle-primary"
                               v-model="isImportAlbumCover" />
                    </div>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'artist_img'">
                <div class="label1">艺术家封面：</div>
                <div style="display: flex;flex-direction: column;">
                    <div style="width: 70%;display: flex;flex-direction: column;" v-if="reloadImg">
                        <div>
                            <bk-upload
                                :files="files2"
                                :theme="'picture'"
                                :multiple="false"
                                :with-credentials="true"
                                :header="uploadHeader"
                                :handle-res-code="handleRes"
                                :size="{ maxFileSize: 5, maxImgSize: 20 }"
                                :url="uploadUrl"
                                name="upload_file"
                            ></bk-upload>
                        </div>
                    </div>
                </div>
            </div>

            <div class="edit-item" v-else-if="item === 'discnumber'">

                <div class="label1 can-copy" v-bk-copy="'${discnumber}'" v-bk-tooltips="'变量名:${discnumber}'">光盘编号：</div>
                <div style="width: 70%;">
                    <input type="text"
                        v-model="musicInfo.discnumber"
                        class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'tracknumber'">
                <div class="label1 can-copy" v-bk-copy="'${tracknumber}'" v-bk-tooltips="'变量名:${tracknumber}'">音轨号：</div>
                <div style="width: 70%;">
                    <input type="text"
                        v-model="musicInfo.tracknumber"
                        class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'totaltracks'">
                <div class="label1">总音轨数：</div>
                <div style="width: 70%;">
                    <input type="text"
                        v-model="musicInfo.totaltracks"
                        class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'totaldiscs'">
                <div class="label1">总光盘数：</div>
                <div style="width: 70%;">
                    <input type="text"
                        v-model="musicInfo.totaldiscs"
                        class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'duration'">
                <div class="label1">时长：</div>
                <div class="badge text-xs">
                    {{ musicInfo.duration }} s
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'bit_rate'">
                <div class="label1">比特率：</div>
                <div class="badge text-xs">
                    {{ musicInfo.bit_rate }} kbps
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'sample_rate'">
                <div class="label1">采样率：</div>
                <div class="badge text-xs">
                    {{ musicInfo.sample_rate }} kHZ
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'bit_depth'">
                <div class="label1">位深度：</div>
                <div class="badge text-xs">
                    {{ musicInfo.bit_depth }} bit
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'channels'">
                <div class="label1">声道：</div>
                <div class="badge text-xs">
                    {{ musicInfo.channels }}
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'size'">
                <div class="label1">文件大小：</div>
                <div class="badge text-xs">
                    {{ musicInfo.size }} MB
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'album_type'">

                <div class="label1">专辑类型：</div>
                <div style="width: 70%;">
                    <select class="select select-bordered select-sm w-full max-w-xs"
                        v-model="musicInfo.album_type">
                        <option v-for="option in albumTypeList"
                            :key="option.id"
                            :value="option.id"
                            class="bg-base-100"
                        >
                            {{ option.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'play'">
                <div class="label1">试听：</div>
                <div style="width: 70%;">
                    <audio controls muted style="width: 90%" :src="playPath">
                    </audio>
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'composer'">

                <div class="label1">作曲家：</div>
                <div style="width: 70%;">
                    <input type="text"
                           v-model="musicInfo.composer"
                           class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            <div class="edit-item" v-else-if="item === 'lyricist'">

                <div class="label1">作词家：</div>
                <div style="width: 70%;">
                    <input type="text"
                           v-model="musicInfo.lyricist"
                           class="input input-bordered input-sm w-full max-w-xs" />
                </div>
            </div>
            </div>
        <bk-dialog v-model="exampleSetting3.primary.visible"
            theme="primary"
            :mask-close="false"
            @confirm="handleSettings"
            :header-position="exampleSetting3.primary.headerPosition"
            title="配置">
            <div>
                <p>选择你的配置，浏览器会保存你的默认值</p>
                <div>标签来源</div>
                <bk-select
                    :disabled="false"
                    :clearable="false"
                    v-model="resource"
                    style="width: 200px;"
                    ext-cls="select-custom"
                    ext-popover-cls="select-popover-custom">
                    <bk-option v-for="option in resourceList"
                        :key="option.id"
                        :id="option.id"
                        :name="option.name">
                    </bk-option>
                </bk-select>
                <div>展示的字段以及顺序</div>
                <bk-select style="width: 350px;margin-top: 10px;"
                    searchable
                    :clearable="false"
                    multiple
                    display-tag
                    v-model="showFields">
                    <bk-option v-for="option in fieldList"
                        :key="option.id"
                        :id="option.id"
                        :name="option.name">
                    </bk-option>
                </bk-select>
            </div>
        </bk-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'music-meta-data',
        props: {
            musicInfo: {type: Object, required: true},
            reloadImg: {type: Boolean, required: true},
            drawerMode: {type: String, required: true}
        },
        data() {
            return {
                exampleSetting3: {
                    primary: {
                        visible: false,
                        headerPosition: 'left'
                    }
                },
                resource: localStorage.getItem('resource') ? localStorage.getItem('resource') : 'netease',
                showFields: localStorage.getItem('showFields') ? JSON.parse(localStorage.getItem('showFields')) : ['filename', 'artist', 'album', 'albumartist', 'genre', 'year', 'lyrics', 'lyrics_file', 'comment', 'album_img', 'size', 'album_type', 'description', 'discnumber', 'tracknumber', 'totaltracks', 'totaldiscs', 'bit_rate', 'sample_rate', 'channels', 'bit_depth', 'language', 'duration'],
                albumTypeList: [
                    {id: 'album;album', name: '普通(album;album)'},
                    {id: 'ep', name: 'EP(ep)'},
                    {id: 'album;compilation', name: '合集(album;compilation)'},
                    {id: 'album;live', name: '现场(album;live)'},
                    {id: 'album;remix', name: '混音(album;remix)'},
                    {id: 'album;soundtrack', name: '原声(album;soundtrack)'},
                    {id: 'album;demo', name: '演示(album;demo)'},
                    {id: 'single', name: '单曲(single)'}
                ],
                isSaveLyricsFile: false,
                isSaveAlbumCover: false,
                isImportAlbumCover: false,
                isImportLyricsFile: false,
                files2: [],
                uploadUrl: '/api/upload_image/',
                uploadHeader: [
                    {name: 'X-CSRFToken', value: this.getCookie('django_vue_cli_csrftoken')},
                    {name: 'AUTHORIZATION', value: this.getCookie('AUTHORIZATION')}
                ],
                genreList: [
                    {'id': '流行', name: '流行'},
                    {'id': '摇滚', name: '摇滚'},
                    {'id': '说唱', name: '说唱'},
                    {'id': '民谣', name: '民谣'},
                    {'id': '电子', name: '电子'},
                    {'id': '爵士', name: '爵士'},
                    {'id': '纯音乐', name: '纯音乐'},
                    {'id': '金属', name: '金属'},
                    {'id': '世界音乐', name: '世界音乐'},
                    {'id': '新世纪', name: '新世纪'},
                    {'id': '古典', name: '古典'},
                    {'id': '独立', name: '独立'},
                    {'id': '氛围音乐', name: '氛围音乐'}
                ],
                languageList: [
                    {'id': '中文', name: '中文'},
                    {'id': '英文', name: '英文'},
                    {'id': '日文', name: '日文'},
                    {'id': '韩文', name: '韩文'},
                    {'id': '法文', name: '法文'},
                    {'id': '泰文', name: '泰文'},
                    {'id': '未知', name: '未知'}
                ],
                fieldList: [
                    {id: 'filename', name: '文件名'},
                    {id: 'artist', name: '艺术家'},
                    {id: 'album', name: '专辑'},
                    {id: 'album_type', name: '专辑类型'},
                    {id: 'albumartist', name: '专辑艺术家'},
                    {id: 'discnumber', name: '光盘编号'},
                    {id: 'tracknumber', name: '音轨号'},
                    {id: 'totaltracks', name: '总音轨数'},
                    {id: 'totaldiscs', name: '总光盘数'},
                    {id: 'genre', name: '风格'},
                    {id: 'year', name: '年份'},
                    {id: 'lyrics', name: '歌词'},
                    {id: 'lyrics_file', name: '歌词(LRC文件)'},
                    {id: 'comment', name: '描述'},
                    {id: 'description', name: '描述2'},
                    {id: 'album_img', name: '专辑封面'},
                    {id: 'duration', name: '时长'},
                    {id: 'size', name: '文件大小'},
                    {id: 'bit_rate', name: '比特率'},
                    {id: 'sample_rate', name: '采样率'},
                    {id: 'channels', name: '声道'},
                    {id: 'bit_depth', name: '位深度'},
                    {id: 'language', name: '语言'},
                    {id: 'play', name: '试听'},
                    {id: 'composer', name: '作曲家'},
                    {id: 'lyricist', name: '作词家'}
                ],
                resourceList: [
                    {id: 'netease', name: '网易云音乐'},
                    {id: 'migu', name: '咪咕音乐'},
                    {id: 'qmusic', name: 'QQ音乐'},
                    {id: 'kugou', name: '酷狗音乐'},
                    {id: 'kuwo', name: '酷我音乐'},
                    {id: 'itunes', name: 'iTunes'},
                    {id: 'acoustid', name: '声纹识别'},
                    {id: 'smart_tag', name: '智能刮削'}
                ]
            }
        },
        computed: {
            ...mapGetters(['geFullPath']),
            isChecked: {
                get() {
                    return this.$store.state.common.checkedIds
                }
            },
            albumArtistList: {
                get() {
                    return this.parseAlbumArtistList(this.musicInfo.artist)
                }
            },
            genreInputList: {
                get() {
                    return this.musicInfo.genre ? [this.musicInfo.genre] : []
                },
                set(value) {
                    this.musicInfo.genre = value.length > 0 ? value[0] : ''
                    return value
                }
            },
            languageInputList: {
                get() {
                    return this.musicInfo.language ? [this.musicInfo.language] : []
                },
                set(value) {
                    this.musicInfo.language = value.length > 0 ? value[0] : ''
                    return value
                }
            },
            albumArtistInputList: {
                get() {
                    return this.musicInfo.albumartist ? [this.musicInfo.albumartist] : []
                },
                set(value) {
                    this.musicInfo.albumartist = value.length > 0 ? value[0] : ''
                    return value
                }
            },
            files1: {
                get() {
                    if (this.musicInfo.artwork) {
                        return [
                            {
                                name: 'cover.png',
                                status: 'done',
                                url: this.musicInfo.artwork
                            }
                        ]
                    } else {
                        return [
                            {
                                name: 'cover.png',
                                status: 'done',
                                url: this.musicInfo.album_img
                            }
                        ]
                    }
                }
            },
            filePath: {
                get() {
                    return this.geFullPath
                }
            },
            playPath: {
                get() {
                    if(this.musicInfo.path) {
                        return this.musicInfo.path.replace("/app/", "/")
                    } else {
                        return ''
                    }
                }
            }
        },
        methods: {
            // 单个音乐保存信息
            handleClick() {
                const musicInfoCopy = JSON.parse(JSON.stringify(this.musicInfo))
                const updatedDictionary = Object.fromEntries(
                    Object.entries(musicInfoCopy).map(([key, value]) => [key, value || '${null}'])
                )
                if (updatedDictionary.files1[0].name === 'new.png') {
                    updatedDictionary.album_img = updatedDictionary.files1[0].url
                }
                const params = [{
                    'is_save_lyrics_file': this.isSaveLyricsFile,
                    'is_import_lyrics_file': this.isImportLyricsFile,
                    'is_save_album_cover': this.isSaveAlbumCover,
                    'is_import_album_cover': this.isImportAlbumCover,
                    'file_full_path': this.musicInfo.path ? this.musicInfo.path : this.filePath + '/' + this.fileName,
                    ...updatedDictionary
                }]
                this.isLoading = true
                this.$api.Task.updateId3({'music_id3_info': params}).then((res) => {
                    this.isLoading = false
                    if (res.result) {
                        this.$cwMessage('修改成功', 'success')
                        // 更新消息中心
                        this.$store.commit('setHasMsg', true)
                        // 刷新目录
                        this.$parent.handleClick()
                    } else {
                        this.$cwMessage(res.message, 'error')
                    }
                })
            },
            // 渲染图片
            handleRes(response) {
                console.log(123)
                if (response.result) {
                    this.musicInfo.album_img = response.data
                    return true
                } else {
                    return false
                }
            },
            toggleLock(mode) {
                this.$parent.toggleLock(this.drawerMode)
            },
            cutOneSecondToLyrics(lyrics) {
                // 使用正则表达式匹配歌词中的时间标记
                const timePattern = /\[(\d{2}):(\d{2}).(\d{2,3})\]/g

                // 使用replace()方法替换匹配到的时间标记
                const newLyrics = lyrics.replace(timePattern, function(match, minutes, seconds, milliseconds) {
                    return ''
                })
                this.musicInfo.lyrics = newLyrics
                return newLyrics
            },
            formatSecondToLyrics(lyrics) {
                // 使用正则表达式匹配歌词中的时间标记
                const timePattern = /\[(\d{2}):(\d{2}).(\d{3})\]/g

                // 使用replace()方法替换匹配到的时间标记
                const newLyrics = lyrics.replace(timePattern, function(match, minutes, seconds, milliseconds) {
                    // 返回新的时间标记
                    return '[' + minutes + ':' + seconds + '.' + milliseconds.slice(-2) + ']'
                })
                this.musicInfo.lyrics = newLyrics
                return newLyrics
            },
            addOneSecondToLyrics(lyrics, mode) {
                // 使用正则表达式匹配歌词中的时间标记
                const timePattern = /\[(\d{2}):(\d{2}).(\d{2,3})\]/g

                // 使用replace()方法替换匹配到的时间标记
                const newLyrics = lyrics.replace(timePattern, function(match, minutes, seconds, milliseconds) {
                    // 将时间转换为秒数
                    let totalSeconds = parseInt(minutes, 10) * 60 + parseInt(seconds, 10)
                    if (totalSeconds !== 0) {
                        if (mode === 'add') {
                            totalSeconds += 1
                        } else {
                            totalSeconds -= 1
                        }
                    }
                    // 将秒数加一

                    // 将秒数转换回时间格式
                    let newMinutes = Math.floor(totalSeconds / 60)
                    let newSeconds = totalSeconds % 60

                    // 格式化为两位数
                    newMinutes = ('0' + newMinutes).slice(-2)
                    newSeconds = ('0' + newSeconds).slice(-2)

                    // 返回新的时间标记
                    return '[' + newMinutes + ':' + newSeconds + '.' + milliseconds + ']'
                })
                this.musicInfo.lyrics = newLyrics
                return newLyrics
            },
            translation() {
                this.$parent.translation()
            },
            // 处理专辑艺术家
            parseAlbumArtistList(artists) {
                let ret = []
                if (artists) {
                    let artistArray = []
                    if (artists.indexOf(',') > -1) {
                        artistArray = artists.split(',')
                    } else if (artists.indexOf('/') > -1) {
                        artistArray = artists.split('/')
                    } else if (artists.indexOf('&') > -1) {
                        artistArray = artists.split('&')
                    } else if (artists.indexOf('、') > -1) {
                        artistArray = artists.split('、')
                    } else if (artists.indexOf('，') > -1) {
                        artistArray = artists.split('，')
                    } else {
                        artistArray = []
                    }
                    artistArray.push(artists)
                    ret = artistArray.map((item) => {
                        return {
                            'id': item,
                            'name': item
                        }
                    })
                }
                return ret
            },
            // 处理设置弹窗
            handleSettings() {
                const obj = JSON.stringify(this.showFields)
                window.localStorage.setItem('showFields', obj)
                window.localStorage.setItem('resource', this.resource)
            },
            extractToLyrics(lyc) {
                this.$api.Task.extractLyric({'lyc': lyc}).then((res) => {
                    if (res.result) {
                        if (res.data !== '') {
                            this.musicInfo['composer'] = res.data.composer
                            this.musicInfo['lyricist'] = res.data.lyricist
                        } else {
                            this.$cwMessage('未找到歌词', 'error')
                        }
                    } else {
                        this.$cwMessage('未找到歌词', 'error')
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
